import { render, staticRenderFns } from "./ZohoCallback.vue?vue&type=template&id=19eb97d4&scoped=true&"
import script from "./ZohoCallback.vue?vue&type=script&lang=ts&"
export * from "./ZohoCallback.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19eb97d4",
  null
  
)

export default component.exports